<template>
  <b-row v-if="$route.meta.breadcrumb || $route.meta.pageTitle" class="content-header" align-h="between">
    <!-- Content Left -->
    <b-col class="content-header-left mb-2 col-8">
      <b-row class="breadcrumbs-top">
        <h2 class="float-left pr-1 mb-0 d-none d-xl-block">
          {{ $route.meta.pageTitle }}
        </h2>
        <h2 class="float-left pr-1 mb-0 d-xl-none d-sm-block">
          <b-img :src="appMobileTextLogoImage" alt="logo" class="logo" @click="onClickVaults" />
          <!-- {{ $route.meta.pageTitleMobile || $route.meta.pageTitle }} -->
        </h2>
        <div class="breadcrumb-wrapper">
          <b-breadcrumb v-if="showDynamicBreadcrumb">
            <b-breadcrumb-item to="/">
              <feather-icon icon="HomeIcon" size="16" class="align-text-top" />
            </b-breadcrumb-item>
            <b-breadcrumb-item v-for="item in breadcrumbData" :key="item.id" :active="item.active" :to="item.to">
              {{ item.text || item.name }}
            </b-breadcrumb-item>
          </b-breadcrumb>
          <b-breadcrumb v-if="!showDynamicBreadcrumb">
            <b-breadcrumb-item to="/">
              <feather-icon icon="HomeIcon" size="16" class="align-text-top" />
            </b-breadcrumb-item>
            <b-breadcrumb-item v-for="item in $route.meta.breadcrumb" :key="item.text" :active="item.active" :to="item.to">
              {{ item.text || item.name }}
            </b-breadcrumb-item>
          </b-breadcrumb>
        </div>
      </b-row>
    </b-col>

    <!-- Content Right -->
    <b-col class="content-header-right text-md-right d-none d-xl-block mb-1" v-if="$auth && $auth.user && profile && profile.firstName">
      <div class="d-flex">
        <ul class="align-self-start dark-toggle-region">
          <dark-Toggler class="dark-toggle " />
        </ul>
        <b-navbar-nav class="align-self-end">
          <b-nav-item-dropdown right toggle-class="d-flex justify-content-end dropdown-user-link" class="dropdown-user">
            <template #button-content>
              <div class="d-sm-flex d-none user-nav align-items-start flex-column">
                <p class="user-name font-weight-bolder mb-0">{{ profile.firstName }} {{ profile.lastName }}</p>
                <span class="user-status text-muted">User</span>
                <!-- <span class="user-status text-muted">{{ $auth && $auth.user ? $auth.user.role : '' }}</span> -->
              </div>
              <b-avatar size="40" variant="light-primary" badge :src="$auth.user.picture" class="badge-minimal" badge-variant="success" />
            </template>

            <b-dropdown-item link-class="d-flex align-items-center" @click="onClickProfile">
              <feather-icon size="16" icon="UserIcon" class="mr-50 menu-icons" />
              <span>Profile</span>
            </b-dropdown-item>
            <b-dropdown-divider />

            <b-dropdown-item link-class="d-flex align-items-center" @click="logout">
              <feather-icon size="16" icon="LogOutIcon" class="mr-50 menu-icons" />
              <span>Logout</span>
            </b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </div>
    </b-col>

    <b-col class="text-right d-xl-none d-block mb-1" v-if="$auth && $auth.user && profile && profile.firstName">
      <b-navbar-nav class="align-self-end">
        <b-nav-item-dropdown right toggle-class="justify-content-end dropdown-user-link" class="dropdown-user">
          <template #button-content>
            <!-- <div class="d-xs-flex d-none user-nav align-items-start flex-column">
              <p class="user-name font-weight-bolder mb-0">{{ profile.firstName }} {{ profile.lastName }}</p>
              <span class="user-status text-muted">User</span>
            </div> -->
            <b-avatar size="40" variant="light-primary" badge :src="$auth.user.picture" class="badge-minimal" badge-variant="success" />
          </template>

          <b-dropdown-item link-class="d-flex align-items-center" @click="onClickProfile">
            <feather-icon size="16" icon="UserIcon" class="mr-50 menu-icons" />
            <span>Profile</span>
          </b-dropdown-item>
          <b-dropdown-divider />

          <b-dropdown-item link-class="d-flex align-items-center" @click="onClickVaults">
            <feather-icon size="16" icon="HardDriveIcon" class="mr-50 menu-icons" />
            <span>Vaults</span>
          </b-dropdown-item>
          <b-dropdown-divider />

          <b-dropdown-item link-class="d-flex align-items-center" @click="onClickRecentFiles">
            <feather-icon size="16" icon="ClockIcon" class="mr-50 menu-icons" />
            <span>Recents</span>
          </b-dropdown-item>
          <b-dropdown-divider />

          <b-dropdown-item link-class="d-flex align-items-center" @click="onClickFavouriteFiles">
            <feather-icon size="16" icon="HeartIcon" class="mr-50 menu-icons" />
            <span>Favourites</span>
          </b-dropdown-item>
          <b-dropdown-divider />

          <b-dropdown-item link-class="d-flex align-items-center" @click="onClickDeletedFiles">
            <feather-icon size="16" icon="TrashIcon" class="mr-50 menu-icons" />
            <span>Deleted</span>
          </b-dropdown-item>
          <b-dropdown-divider />

          <b-dropdown-item link-class="d-flex align-items-center" @click="logout">
            <feather-icon size="16" icon="LogOutIcon" class="mr-50 menu-icons" />
            <span>Logout</span>
          </b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-col>
  </b-row>
</template>

<script>
import {
  BBreadcrumb,
  BBreadcrumbItem,
  BImg,
  BRow,
  BCol,
  BAvatar,
  BLink,
  BNavbarNav,
  BNavItemDropdown,
  BDropdownItem,
  BDropdownDivider
} from 'bootstrap-vue'
import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'
import Ripple from 'vue-ripple-directive'
import { mapState } from 'vuex'
import { $themeConfig } from '@themeConfig'

export default {
  directives: {
    Ripple
  },
  components: {
    BBreadcrumb,
    BBreadcrumbItem,
    BImg,
    BRow,
    BCol,
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
    // Navbar Components
    DarkToggler
  },
  data: function() {
    return { showDynamicBreadcrumb: false }
  },
  computed: {
    ...mapState('userProfile', ['profile']),
    ...mapState('appBreadcrumb', ['breadcrumbData'])
  },
  watch: {
    $route: {
      handler(newVal, oldVal) {
        this.showDynamicBreadcrumb = newVal.name === 'contents'

        if (this.showDynamicBreadcrumb && this.$store.state.appBreadcrumb.breadcrumbData.length === 0) {
          this.$store.dispatch('appBreadcrumb/refreshBreadcrumb', {
            self: this,
            organisationId: this.$route.params.organisationId,
            groupId: this.$route.params.groupId
          })
        }

        const match = this.$store.state.appBreadcrumb.breadcrumbData
          .map(x => x.id)
          .indexOf(newVal.params.folderId !== '0' ? newVal.params.folderId : newVal.params.vaultId)
        const goToParent = match > -1 && match !== this.$store.state.appBreadcrumb.breadcrumbData.length - 1 //exists and is not the leaf node

        if (goToParent) {
          this.$store.dispatch('appBreadcrumb/goToParentBreadcrumb', {
            self: this,
            organisationId: this.$route.params.vaultId,
            groupId: this.$route.params.groupId
          })
        }
      },
      immediate: true
    }
  },
  methods: {
    logout() {
      // Clear any cache
      sessionStorage.clear()
      this.$auth.logout({
        returnTo: window.location.origin
      })
    },
    onClickVaults() {
      this.$router.push('/vaults')
    },
    onClickRecentFiles() {
      this.$router.push('/recent-contents')
    },
    onClickFavouriteFiles() {
      this.$router.push('/favourites')
    },
    onClickDeletedFiles() {
      this.$router.push('/deleted')
    },
    onClickProfile() {
      if (this.$router.currentRoute.path !== '/account-setting') {
        this.$router.push('/account-setting')
      }
    }
  },
  setup() {
    // App Name
    const { appName, appMobileTextLogoImage } = $themeConfig.app
    return {
      appName,
      appMobileTextLogoImage
    }
  }
}
</script>
<style lang="scss" scoped>
.badge-minimal {
  margin-left: 1em;
}

.inline-header {
  display: inline-block;
}

.content-header-right {
  padding-right: 2em;
}
.content-header-left {
  margin-left: 1rem;
}

.menu-icons {
  margin-right: 1em !important;
  width: 24px;
  height: 24px;
}

.dark-toggle {
  border-right: 1px solid #333;
  margin-right: 1rem;
  margin-top: 0.5rem;
  margin-bottom: 0;
}

ul {
  list-style-type: none;
}

.dark-toggle-region {
  margin-left: auto;
}
.profile-region {
  margin-left: 0;
}

.content-header {
  align-items: flex-end;
}

.logo {
  height: 24px;
  @media (max-width: 576px) {
    margin-left: 2rem;
  }
}
</style>
